import { useCallback, useContext } from "react";
import {
    Toast,
    ToastBody,
    ToastTitle,
    useToastController,
} from "@fluentui/react-components";
import { Context } from "../context";

/**
 * Shared hook for dispatching Fluent UI toasts wired through App-level toaster.
 * Falls back gracefully when no toaster is available (e.g., in unit tests).
 */
export const useToast = () => {
    const contextValue = useContext(Context);
    const { toasterId } = contextValue ?? {};
    const { dispatchToast } = useToastController(toasterId);

    return useCallback(
        (title, intent = "info", body, options = {}) => {
            if (!dispatchToast) {
                return;
            }

            dispatchToast(
                <Toast>
                    <ToastTitle>{title}</ToastTitle>
                    {body ? <ToastBody>{body}</ToastBody> : null}
                </Toast>,
                { intent, ...options }
            );
        },
        [dispatchToast]
    );
};
